import { cn } from '@baseball-near-you/ui';
import Image, { type ImageProps } from 'next/image';
import type { ReactEventHandler } from 'react';

export function ResponsiveNextImage({
  imageClassName,
  containerClassName,
  nextImageProps,
  onLoad,
}: {
  imageClassName?: string;
  containerClassName?: string;
  nextImageProps: ImageProps;
  onLoad?: ReactEventHandler<HTMLImageElement>;
}) {
  return (
    <div className={cn('relative', containerClassName)}>
      {!!nextImageProps.src && (
        <Image
          {...nextImageProps}
          className={nextImageProps.className}
          onLoad={onLoad}
        />
      )}
    </div>
  );
}
